import { Injectable } from '@angular/core';
import { CusHttp } from "../../core/services/CusHttp";
import { URLSearchParams } from '@angular/http';
//获取二级分类
const TWO_CLASSIFY = 'v1/course-direction/list';
//获取所有课程
const GET_COURSE = 'v1/course-package/search';

//获取精品课程分类
const TOP_CLASSIFY = "v1/course-category/list";
//获取分类中第一个标签的课程
const TOP_COURSE = "v1/course-category/best-course";


@Injectable()
export class TopCourseService {
  constructor( private _http: CusHttp ) {
  }

  //获取二级分类
  getTwoClassify( id?: any, level?: any ) {
    let a = new URLSearchParams;
    id && a.append( 'id', id );
    level && a.append( 'level', level );
    return this._http.get( `${TWO_CLASSIFY}?` + a.toString() );
  }

  //获取所有课程
  getCourse( id?: number, level?: number ) {
    let a = new URLSearchParams;
    id && a.append( 'id', id.toString() );
    level && a.append( 'level', level.toString() );
    return this._http.get( `${GET_COURSE}?` + a.toString() );
  }

  //获取精品课程分类
  getTopClassify() {
    return this._http.get( `${TOP_CLASSIFY}` );
  }

  //获取分类中第一个标签的课程
  getTopCourse() {
    return this._http.get( `${TOP_COURSE}` );
  }

}

















// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/top-course/top-course.service.ts